import React from 'react';
import { useAuthContext } from './auth/AuthProvider';
import { twMerge } from 'tailwind-merge';
import Button from './Button';
import { roleDisplayNames } from './auth/authConfig';
import { useNavigate } from 'react-router-dom';
import { hasPermission, permissions } from '../config/permissions';
import { useMutation } from '@tanstack/react-query';
import API from '../services/api';
import { toast } from 'react-toastify';
import Menu from './menu';
import { useGlobalContext } from './context/GlobalProvider';

export const Header = () => {
  const { user, handleLogout } = useAuthContext();
  const { hasPendingChanges } = useGlobalContext();

  const navigate = useNavigate();
  const mutation = useMutation({
    mutationFn: () => API.sync.syncData(),
    onSuccess: () => {
      //refresh the page
      toast.success('Data synced successfully');
      navigate(0);
    },
    onError: (error) => {
      toast.error(error?.message || 'Failed to sync data');
    },
  });

  return (
    <div
      className={twMerge(
        'fixed left-0 top-0 z-10 flex h-15 w-screen items-center justify-between border-b border-gray-200 bg-white px-10',
      )}
    >
      <div className="container mx-auto flex items-center justify-between py-2">
        <Menu />
        <div className="flex items-center gap-4">
          {user && (
            <>
              <div className="flex items-end flex-col">
                <span className="text-sm">
                  {user.name || user.email}{' '}
                  <span className="text-xs text-gray-500">
                    (
                    {user.roles
                      ?.map((role) => roleDisplayNames[role])
                      .join(', ')}
                    )
                  </span>
                </span>
              </div>
              <Button variant="secondary" size="sm" onClick={handleLogout}>
                Log out <span aria-hidden="true">&rarr;</span>
              </Button>
            </>
          )}
          {hasPermission(user?.permissions, permissions.CAN_RE_SYNC) && (
            <Button
              size="sm"
              disabled={hasPendingChanges}
              loading={mutation.isPending}
              onClick={() => mutation.mutate()}
            >
              Re Sync
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
